/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UnlinkHubspotDealInput = {|
  projectId?: ?string,
  dealId?: ?string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type UnlinkHubspotDealMutationVariables = {|
  input: UnlinkHubspotDealInput
|};
export type UnlinkHubspotDealMutationResponse = {|
  +unlinkHubspotDeal: ?{|
    +project: ?{|
      +hubspotDeal: ?string
    |}
  |}
|};
export type UnlinkHubspotDealMutation = {|
  variables: UnlinkHubspotDealMutationVariables,
  response: UnlinkHubspotDealMutationResponse,
|};
*/


/*
mutation UnlinkHubspotDealMutation(
  $input: UnlinkHubspotDealInput!
) {
  unlinkHubspotDeal(input: $input) {
    project {
      hubspotDeal
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UnlinkHubspotDealInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hubspotDeal",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UnlinkHubspotDealMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UnlinkHubspotDealPayload",
        "kind": "LinkedField",
        "name": "unlinkHubspotDeal",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UnlinkHubspotDealMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UnlinkHubspotDealPayload",
        "kind": "LinkedField",
        "name": "unlinkHubspotDeal",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "UnlinkHubspotDealMutation",
    "operationKind": "mutation",
    "text": "mutation UnlinkHubspotDealMutation(\n  $input: UnlinkHubspotDealInput!\n) {\n  unlinkHubspotDeal(input: $input) {\n    project {\n      hubspotDeal\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b842767bc2a184f498cfff7926545aa0';

module.exports = node;
